import { render, staticRenderFns } from "./FastComponent.vue?vue&type=template&id=226f43a4"
import script from "./FastComponent.vue?vue&type=script&lang=js"
export * from "./FastComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports